import { render, staticRenderFns } from "./ArticlesFilterSidebar.vue?vue&type=template&id=d8a07822&scoped=true"
import script from "./ArticlesFilterSidebar.vue?vue&type=script&lang=js"
export * from "./ArticlesFilterSidebar.vue?vue&type=script&lang=js"
import style0 from "./ArticlesFilterSidebar.vue?vue&type=style&index=0&id=d8a07822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a07822",
  null
  
)

export default component.exports